import React, { memo, ReactElement } from "react";
import { AriaHidden } from "@swiggy-private/core-ui";
import { VEG_TYPE } from "@swiggy-private/cart-types";
export interface FoodSymbolIconSvgProps {
    className?: string;
    size?: number;
    vegType: VEG_TYPE;
    containerClassName?: string;
}

const STROKE_COLOR = {
    0: "#E43B4F", // Non Veg
    1: "#0F8A65", // Veg
    2: "#E43B4F", // Egg
};
const OuterBoxPathV4 =
    "M6 1.05c1.444 0 2.421.002 3.152.101.7.094 1.015.258 1.227.47.212.212.376.527.471 1.227.098.731.1 1.708.1 3.152 0 1.444-.002 2.421-.1 3.152-.095.7-.259 1.015-.471 1.227-.212.212-.527.376-1.227.47-.731.099-1.708.101-3.152.101-1.444 0-2.421-.002-3.152-.101-.7-.094-1.015-.258-1.227-.47-.212-.212-.376-.527-.471-1.227-.098-.731-.1-1.708-.1-3.152 0-1.444.002-2.421.1-3.152.095-.7.259-1.015.471-1.227.212-.212.527-.376 1.227-.47C3.579 1.052 4.556 1.05 6 1.05Zm5.121-.171C10.243 0 8.828 0 6 0 3.172 0 1.757 0 .879.879 0 1.757 0 3.172 0 6c0 2.828 0 4.243.879 5.121C1.757 12 3.172 12 6 12c2.828 0 4.243 0 5.121-.879C12 10.243 12 8.828 12 6c0-2.828 0-4.243-.879-5.121Z";

function FoodSymbolIconSvg(props: FoodSymbolIconSvgProps): ReactElement {
    const { size = 12, vegType, className, containerClassName } = props;
    const strokeColor = STROKE_COLOR[vegType];
    const isVeg = vegType === 1;

    return (
        <AriaHidden as="span" className={containerClassName}>
            <svg
                width={size}
                height={size}
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={className}
            >
                <path d={OuterBoxPathV4} fill={strokeColor} />
                {!isVeg && (
                    <path
                        d="M2.79 8.229c.143.257.54.257 1.334.257h3.752c.794 0 1.191 0 1.334-.257.143-.257-.066-.594-.484-1.27L6.85 3.93c-.381-.616-.571-.923-.85-.923-.278 0-.469.307-.85.923L3.274 6.959c-.418.676-.627 1.013-.484 1.27Z"
                        fill={strokeColor}
                    />
                )}
                {isVeg && <path d="M6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" fill={strokeColor} />}
            </svg>
        </AriaHidden>
    );
}
export default memo(FoodSymbolIconSvg);
